"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeLeadingTrailingCharacters = exports.sanitizeStringLength = exports.sanitizeHtmlString = exports.sanitizeDashedString = exports.sanitizeStringName = void 0;
function sanitizeStringName(str) {
    return str
        .trim()
        .replace(/[^a-zA-Z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '') // remove leading or trailing underscores
        .toLowerCase();
}
exports.sanitizeStringName = sanitizeStringName;
function sanitizeDashedString(str) {
    return str.trim().replace(/-/g, '_');
}
exports.sanitizeDashedString = sanitizeDashedString;
function sanitizeHtmlString(str) {
    return str.trim().replace(/<[^>]*>/g, '');
}
exports.sanitizeHtmlString = sanitizeHtmlString;
function sanitizeStringLength(str, maxLength) {
    const ELLIPSIS_STR = '...';
    return str.length > maxLength ? `${str.slice(0, maxLength - ELLIPSIS_STR.length)}${ELLIPSIS_STR}` : str;
}
exports.sanitizeStringLength = sanitizeStringLength;
function sanitizeLeadingTrailingCharacters(str, characters) {
    const chars = characters.join('');
    const regex = new RegExp(`^[${chars}]+|[${chars}]+$`, 'g');
    return str.replace(regex, '');
}
exports.sanitizeLeadingTrailingCharacters = sanitizeLeadingTrailingCharacters;
//# sourceMappingURL=sanitize.js.map